import { SolutionsPage } from './SolutionsPage';

export { SolutionsPage };
